export const editConditionPath = (
  expId: string | number,
  cellConditionId: string | number,
  isExternalCell: boolean = false
) => `/experiments/${expId}/conditions/${ isExternalCell ? "external?condition=" + cellConditionId : cellConditionId}`;
